"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = void 0;
const react_1 = __importStar(require("react"));
const RadixDropdownMenu = __importStar(require("@radix-ui/react-dropdown-menu"));
const DropdownMenu_styles_1 = require("./DropdownMenu.styles");
const Root = RadixDropdownMenu.Root;
const Trigger = RadixDropdownMenu.Trigger;
Trigger.defaultProps = {
    /**
     * This prop is passed to fix trigger behaviour on mobile
     * as without it the dropdown menu is closed immediately after opening
     */
    onFocusCapture: (event) => {
        event.stopPropagation();
    },
};
const Content = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children, forceMount, container, size } = _a, props = __rest(_a, ["children", "forceMount", "container", "size"]);
    return (react_1.default.createElement(RadixDropdownMenu.Portal, { forceMount: forceMount, container: container },
        react_1.default.createElement(DropdownMenu_styles_1.StyledPortal, null,
            react_1.default.createElement(RadixDropdownMenu.Content, Object.assign({ ref: forwardedRef, asChild: true }, props),
                react_1.default.createElement(DropdownMenu_styles_1.StyledContent, { "$size": size }, children)))));
});
Content.defaultProps = {
    size: "small",
};
const Item = DropdownMenu_styles_1.StyledItem;
const Divider = DropdownMenu_styles_1.StyledDivider;
const Header = DropdownMenu_styles_1.StyledHeader;
const RadioGroup = DropdownMenu_styles_1.StyledRadioGroup;
const RadioItem = DropdownMenu_styles_1.StyledRadioItem;
Root.displayName = "DropdownMenu";
Trigger.displayName = "DropdownMenu.Trigger";
Content.displayName = "DropdownMenu.Content";
Item.displayName = "DropdownMenu.Item";
Divider.displayName = "DropdownMenu.Divider";
Header.displayName = "DropdownMenu.Header";
RadioGroup.displayName = "DropdownMenu.RadioGroup";
RadioItem.displayName = "DropdownMenu.RadioItem";
exports.DropdownMenu = Object.assign(Root, {
    Trigger,
    Content,
    Item,
    Divider,
    Header,
    RadioGroup,
    RadioItem,
});
//# sourceMappingURL=DropdownMenu.js.map